import { Grid } from '@material-ui/core'
import { HeaderNavigation as Navigation } from 'shared/components'
import {
  Container,
  Title,
  Icon,
  GoBackTitle,
  GoBackWrapper,
} from './ViewHeader.style'

interface HeaderProps {
  title: string
  routes: {
    route: string
    title: string
  }[]
  goBack?: {
    title: string
    onClick(): void
  }
}

const ViewHeader = ({ title, routes, goBack }: HeaderProps) => {
  return (
    <Grid container alignItems="flex-start" justifyContent="space-between">
      <Container>
        <Title variant="h3">{title}</Title>
        <Navigation routes={routes} />
      </Container>
      {!!goBack && (
        <GoBackWrapper onClick={goBack.onClick}>
          <Icon />
          <GoBackTitle>{goBack.title}</GoBackTitle>
        </GoBackWrapper>
      )}
    </Grid>
  )
}

export default ViewHeader
